module.exports = __webpack_public_path__ + "static/APC-bdcc01c1946c404f91b506f5f56c6476.jpg";